import { deletedata } from '@/util/global';
import React from 'react';

const DashboardTableItem = ({ itemdata }) => {
  const rows = [];

  for (let i = 0; i < itemdata.length; i++) {
    const a = itemdata[i];
    rows.push(
      <tr key={a._id || i}>
        <td>
          <select 
            className="action-select" 
            value="" 
            onChange={(e) => {
              e.target.value === "Edit" && openedit(a);
              e.target.value === "Delete" && deletephonenumber(a);
              e.target.value === "Send" && opensend(a);
              e.target.value === "Webhook" && openwebhook(a);
            }}
          >
            <option value="" disabled>{i + 1}</option>
            <option value="Edit">Edit</option>
            <option value="Send">Send Message</option>
            <option value="Webhook">Setup Webhook</option>
            <option value="Delete">Delete</option>

          </select>
        </td>
        <td>{a.name}</td>
        <td>{a.phonenumber}</td>
 
        <td>
          {a.status}
        </td>
      </tr>
    );
  }

  return (
    <table className="grid" >
      <thead>
        <tr><th style={{width:'30px'}}>Action</th><th>Name</th><th>Phone Number</th><th>Status</th></tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default DashboardTableItem;